module.exports = __webpack_public_path__ + "img/frame-browser-foujita-es.5bbda7f8.jpg";